
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';
import 'react-reflex/styles.css';
import { useRecoilValue, useSetRecoilState } from "recoil";
import getSchema from "../../lib/api/getSchema";
import authProfileState from "../../states/authProfileState";
import { useTranslation } from "react-i18next";
import notificationState from "../../states/notificationState";

import layoutConf from "../../config/layoutConf";
import MomSysStockTakingDetail from "./MomSysStockTakingDetail";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import ApprovalButton from "../input/ApprovalButton";
import AccessControl from "../functional/AccessControl";
import MomSysApplyStockTakingButton from "../input/MomSysApplyStockTakingButton";
import CreateStockTakingButton from "../input/CreateStockTakingButton";
import defineConf from "../../config/defineConf";

function MomSysStockTakingMst (props ) {

    const { t } = useTranslation ();

    const [ grid, setGrid ] = useState();

    const [ height, setHeight ] = useState(0);

    const [stockTakingId , setStockTakingId] = useState();

    const [mstRefresh , setMstRefresh ] = useState ();
    
    const [ approvalState, setApprovalState ] = useState();

    const [ approvalCtx, setApprovalCtx ] = useState ();

    const authProfile = useRecoilValue ( authProfileState );

    const [ stockTakingMstSchema, setStockTakingMstSchema ] = useState ();

    const [ logAdjustSchema, setLogAdjustSchema ] = useState ();
    
    const [appDate, setAppDate] = useState();

    const [ isEmpty, setIsEmpty ] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {

        window.addEventListener('resize', handleResize);
        handleResize();

        let mounted = true;

        ( async() => {

          let schema ;
          
          schema = await getSchema("MomSysUglStockTakingMst");

          if ( mounted ) {

            setStockTakingMstSchema(schema);

          }
          
          schema = await getSchema("MomSysLogAdjust");

          if ( mounted ) {

            setLogAdjustSchema(schema);

          }
          
        } ) ();

        return ( () => {

            mounted = false;
            window.removeEventListener('resize', handleResize);

        } );
    
      }, []);

      useEffect(() => {

        ( async () => {

            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {

                    setStockTakingId(grid.selectedItems[0] && grid.selectedItems[0].stockTakingId);
                    setApprovalState(grid.selectedItems[0] && grid.selectedItems[0].approvalState);
                    setAppDate(grid.selectedItems[0] && grid.selectedItems[0].appDate);
                    
                });
                
                grid.itemsSourceChanged.addHandler((grid, event) => {
                    
                    setStockTakingId(grid.selectedItems[0] && grid.selectedItems[0].stockTakingId);
                    setApprovalState(grid.selectedItems[0] && grid.selectedItems[0].approvalState);
                    setAppDate(grid.selectedItems[0] && grid.selectedItems[0].appDate);

                });
            }

        } ) ()


    }, [grid] )

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    const onLoadData = ( data ) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const onInitialized = (grid) => {

        grid.selectionMode = "Row";

        setGrid(grid);

    }

    const onMstApiInitialized = ( api ) => {

        setMstRefresh ( api );

    }

    useEffect ( () => {
        
        let approvalCtx = {
    
            approvalTypeId: 7,
            tableName: "MomSysUglStockTakingMst",
            statusColumn: "approved",
            schema: stockTakingMstSchema,
            onValidateApprovalItem: ( item ) => {

                if ( item.createdBy !== authProfile.username ) {
    
                    return [ false, t( "error.approvalRequesterNotMatch" ) ];
        
                    
                }
        
                return [ true, "" ];
        
            },
            makeRequestItemDescription: ( item ) => {
                return `${t("approvalRequestMsg.msg.stockTaking", {stockTakingId : item.stockTakingId})}`; // Use Translation on Production Code
    
            }
        
        };
    
        setApprovalCtx ( approvalCtx );
    
    }, [stockTakingMstSchema] );

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const onSuccess = ( msg ) => {
    
        notifySuccess ( msg );
    
    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const onFailure = ( reason ) => {
    
        notifyFailure ( reason.response ? reason.response.data : reason );
    
    };

    return (

        <div style={{ height: height }} >

            <ReflexContainer orientation="horizontal">

                <ReflexElement flex={0.6}>

                    <BasicCrudScreenType 
                        id="MomSysUglStockTakingMst"
                        table = "MomSysUglStockTakingMst"
                        view="MomSysZvwStockTakingMst" 
                        headerTitle = {t("term.stockTakingList")}
                        onInitialized={onInitialized}
                        onApiInitialized={onMstApiInitialized}
                        onLoadData = {onLoadData}
                        noEdit
                        noDelete
                        noCreate
                        noExcel
                        onAppendButtonInFrontOfSearch = {
                            () => (
                                <>
                                <BasicCrudScreenActionItemLayout>
                                    <CreateStockTakingButton
                                        id= "MomSysUglStockTakingMst"
                                        schema={stockTakingMstSchema}
                                        refresh={mstRefresh}
                                        onSuccess={onSuccess}
                                        stockTakingType = {defineConf.stockTakingType.ALL}
                                        createButtonName = {"newStockTaking"}
                                    />

                                    <AccessControl accessTarget={stockTakingMstSchema && stockTakingMstSchema.name} accessMethod="APPROVAL">
                                        <ApprovalButton
                                            id= "MomSysUglStockTakingMst"
                                            grid={grid}
                                            refresh={mstRefresh}
                                            approvalCtx={approvalCtx}
                                            onSuccess={onSuccess}
                                            onFailure={onFailure}
                                            disabled = {isEmpty}
                                        />
                                    </AccessControl>
                                    <MomSysApplyStockTakingButton
                                        id={"MomSysApplyStockTakingButton"}
                                        schema={logAdjustSchema}
                                        grid={grid}
                                        refresh={mstRefresh}
                                        disabled = {!Boolean(approvalState === defineConf.approvalState.APPROVED) || Boolean(appDate)}
                                        stockTakingId ={stockTakingId}
                                        onSuccess={notifySuccess}
                                    />

                                </BasicCrudScreenActionItemLayout>
                                </>
                                )
                            }
                        
                    />

                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement>
                        <MomSysStockTakingDetail
                            id = "MomSysStockTakingDetail"
                            mstSchema = {stockTakingMstSchema}
                            stockTakingId = {stockTakingId}
                            approvalState = {approvalState}
                        />
                </ReflexElement>

            </ReflexContainer>

        </div>

    );

}

export default MomSysStockTakingMst;
